import './sticky-tab-strip.css';
import i18n from '@/i18n/i18n';

export interface StickyTabItem<T extends string = string> {
  id: T;
  label: string;
  count?: number;
}

interface StickyTabStripProps<T extends string> {
  tabs: StickyTabItem<T>[];
  activeTab: T;
  onTabChange: (tab: T) => void;
  ariaLabel?: string;
  className?: string;
}

function StickyTabStrip<T extends string>({
  tabs,
  activeTab,
  onTabChange,
  ariaLabel,
  className = ''
}: StickyTabStripProps<T>) {
  return (
    <div
      className={`sticky-tab-strip${className ? ` ${className}` : ''}`}
      role="tablist"
      aria-label={ariaLabel ?? i18n.t('common:aria.sections')}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            id={`tab-${tab.id}`}
            aria-selected={isActive}
            aria-controls={`panel-${tab.id}`}
            className={`sticky-tab-strip__tab${isActive ? ' sticky-tab-strip__tab--active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
            {tab.count !== undefined && <span className="sticky-tab-strip__count">{tab.count}</span>}
          </button>
        );
      })}
    </div>
  );
}

export default StickyTabStrip;
